import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Home from './Pages/Home'
import About from './Pages/About'
import Navbar from '../src/Components/Nav_bar'
import Fproject from './Pages/project_page/Fproject_page'
import Uxproject from './Pages/project_page/Uxproject_page'
import Uiproject from './Pages/project_page/Uiproject_page'
import Dailyproject from './Pages/project_page/Dailyproject_page'

// import axios from 'axios';

export default class App extends Component {

  render() {
    return (
      <div>          
      <Router>
        <Navbar />
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route path="/Fproject" component={Fproject} />
        <Route path="/Uxproject" component={Uxproject} />  
        <Route path="/Uiproject" component={Uiproject} />  
        <Route path="/Dailyproject" component={Dailyproject} />
      </Router>
      </div>
    )
  }
}